import { deletePurchaseTemplate, selectPurchaseTemplate, resetCurrentPurchaseTemplate } from '../../actions/purchaseTemplates_actions';
import { connect } from 'react-redux';

import CustomerItems from '../../components/Returns/customerItems'

function mapStateToProps(state) {
    return {
        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        purchaseTemplates: state.purchaseTemplates.all,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { deletePurchaseTemplate, selectPurchaseTemplate, resetCurrentPurchaseTemplate })(CustomerItems);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/customerItems.jsx